import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core'

import theme from 'theme'
import styles from './styles'

import constants from 'constants/index'

const { ATTENDANCE_BASE_ITEMS, POLICIES_DESCRIPTION } = constants.privacyPortal

const IframePreview = ({
  primaryColor,
  secondaryColor,
  secondaryTextColor,
  pageTitle,
  pageSubtitle,
  showCompanyInfo,
  showPrivacyPolicies,
  complaintActivated,
  zoom = 100,
}) => {
  const useStyles = styles({
    primaryColor,
    secondaryColor,
    secondaryTextColor,
  })
  const classes = useStyles()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'))
  const cardSpacingBase = isSmallScreen ? 1 : 2
  const sectionPadding = isSmallScreen ? 3 : 5
  const horizontalPadding = isSmallScreen ? 3 : 8
  const cardMinHeight = isSmallScreen ? 140 : 200
  const stacked = zoom >= 150
  const scaledCardMinHeight = Math.round(cardMinHeight * (zoom / 100))
  const edgeBase = isSmallScreen ? 1 : 2
  const edgePadding =
    zoom >= 100 ? edgeBase : Math.round(edgeBase * (100 / zoom))
  const cardSpacing =
    zoom >= 100 ? cardSpacingBase : Math.round(cardSpacingBase * (100 / zoom))

  const attendanceItems = [
    ...ATTENDANCE_BASE_ITEMS,
    ...(complaintActivated ? ['Realizar denúncia'] : []),
  ]

  return (
    <Box className={classes.wrapper} boxShadow={1}>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(isSmallScreen ? 3 : 5)}
        p={sectionPadding}
      >
        <Box display="flex" flexDirection="column">
          {showCompanyInfo && (
            <Box
              className={classes.header}
              boxShadow={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
              pt={3}
              pb={6}
            >
              <Box width="100%" px={horizontalPadding}>
                <Box className={classes.titleBox} p={4}>
                  <Typography className={classes.titleText} variant="body2">
                    {pageTitle || 'Esta organização é amiga da privacidade'}
                  </Typography>
                  <Typography className={classes.titleText} variant="body2">
                    {pageSubtitle ||
                      'em relação a Lei Geral de Proteção de Dados'}
                  </Typography>
                </Box>
                <Box
                  bgcolor={theme.palette.common.white}
                  boxShadow={1}
                  display="flex"
                  flexDirection="row"
                  p={4}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={5}
                      sm={3}
                      component={Box}
                      minHeight={80}
                      className={classes.companyLogo}
                    />
                    <Grid
                      item
                      xs={7}
                      sm={9}
                      component={Box}
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      pl={4}
                    >
                      <Typography variant="body2" noWrap>
                        <strong>Dados da empresa</strong>
                      </Typography>
                      <Typography variant="body2" noWrap>
                        DPO responsável
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          )}
          <Box bgcolor={theme.palette.common.white} boxShadow={1}>
            <Box p={edgePadding}>
              <Grid container spacing={cardSpacing}>
                {attendanceItems.map((item) => (
                  <Grid item xs={12} sm={stacked ? 12 : 6} key={item}>
                    <Box
                      display="flex"
                      minHeight={scaledCardMinHeight}
                      alignItems="flex-end"
                      boxShadow={1}
                      borderRadius={1}
                      p={sectionPadding}
                    >
                      <Box
                        className={classes.attendanceCard}
                        boxShadow={1}
                        width="100%"
                        p={2}
                      >
                        <Typography
                          className={classes.attendanceCardText}
                          variant="body1"
                        >
                          {item}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
            {showPrivacyPolicies && (
              <Box>
                <Typography
                  className={classes.policiesTitle}
                  variant="h6"
                  align="center"
                  gutterBottom
                >
                  Termos, avisos e políticas
                </Typography>
                <Box py={4} px={horizontalPadding}>
                  <Typography variant="body2" align="justify">
                    {POLICIES_DESCRIPTION}
                  </Typography>
                </Box>
                <Box p={edgePadding}>
                  <Grid container spacing={cardSpacing}>
                    {Array.from({ length: 2 }, (_, index) => (
                      <Grid item xs={12} sm={stacked ? 12 : 6} key={index}>
                        <Box
                          display="flex"
                          minHeight={scaledCardMinHeight}
                          alignItems="flex-end"
                          boxShadow={1}
                          borderRadius={1}
                          p={sectionPadding}
                        >
                          <Box
                            className={classes.policyCard}
                            boxShadow={1}
                            width="100%"
                            p={2}
                          >
                            <Typography
                              className={classes.policyCardText}
                              variant="body1"
                            >
                              Ver mais
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

IframePreview.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  secondaryTextColor: PropTypes.string,
  pageTitle: PropTypes.string,
  pageSubtitle: PropTypes.string,
  showCompanyInfo: PropTypes.bool,
  showPrivacyPolicies: PropTypes.bool,
  complaintActivated: PropTypes.bool,
  zoom: PropTypes.number,
}

export default IframePreview
